import { createContext } from 'react';

import { NavBarProps } from '../NavBar';

export interface NavBarContextProps {
  responsiveBreakpoint: NavBarProps['responsiveBreakpoint'];
  getBreakpointClassName: (
    className: string,
    includeBaseClass?: boolean,
  ) => string;
  useMobileDrawer?: boolean;
}

const NavBarContext = createContext<NavBarContextProps>({
  responsiveBreakpoint: 'sm',
  getBreakpointClassName: () => '',
  useMobileDrawer: true,
});

export default NavBarContext;
